/*
 * TunePad
 *
 * Michael S. Horn
 * Northwestern University
 * michael-horn@northwestern.edu
 *
 * This project was funded by the National Science Foundation (grant DRL-1612619).
 * Any opinions, findings and conclusions or recommendations expressed in this
 * material are those of the author(s) and do not necessarily reflect the views
 * of the National Science Foundation (NSF).
 */
import html from './share-dialog.module.html';
import { Creator, Renderer } from 'easy-qrcode';


const ValidShareOptions = ['private', 'viewonly', 'collaborative'] as const;
export type ShareOption = typeof ValidShareOptions[number];


/**
 * Project sharing options
 */
export function showShareDialog(mode : string, link : string, update : (mode : string) => void) : HTMLDialogElement {

    const dialog = document.createElement('dialog');
    dialog.innerHTML = html;
    dialog.classList.add('share-dialog');
    document.body.append(dialog);
    setMode(mode);
    generateQRCode(link);

    const input = dialog.querySelector('#share-url') as HTMLInputElement;
    input.value = link;
    input.addEventListener('focus', e => input.select());

    dialog.querySelector('#copy-button')?.addEventListener('click', e => {
        navigator.clipboard.writeText(input.value);
        input.select();
    });

    dialog.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', e => {
            const value = (radio as HTMLInputElement).value;
            setMode(value);
            update(value);
        });
    });

    dialog.addEventListener('click', (event) => {
        const r = dialog.getBoundingClientRect();
        const cx = event.clientX;
        const cy = event.clientY;
        if (cy < r.top || cy > r.bottom || cx < r.left || cx > r.right) {
            dialog.close();
            dialog.remove();
        }
    });

    dialog.querySelector('#close-button')?.addEventListener('click', e => {
        dialog.close();
        dialog.remove();
    });


    (dialog as any).updateLink = (link : string) => {
        input.value = link;
        generateQRCode(link);
    }

    dialog.showModal();


    function setMode(mode : string) {
        const opt = dialog.querySelector(`#option-${mode}`);
        if (opt) { (opt as HTMLInputElement).checked = true }
    }


    function generateQRCode(url : string) {
        const qrCreator = new Creator();
        const qrRenderer = new Renderer();
        const canvas = dialog.querySelector('canvas#qrcode');
        qrCreator.add(url);
        qrCreator.create();
        const matrix = qrCreator.getMatrix();
        qrRenderer.drawCanvas(matrix, canvas as HTMLCanvasElement);
    }

    return dialog;
}
